import axios from 'axios';
import getKeycloakInstance from '../core/auth/keycloak';
//import { useKeycloak } from "@react-keycloak/web";
import logger from '../core/utils/logger';

// ✅ Read API URL from Environment Variables
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:5000/api";
logger.log("API_BASE_URL", API_BASE_URL);

// ✅ Function to Get Keycloak Token
const getAuthToken = async () => {
  const keycloak = getKeycloakInstance();
  if (!keycloak.authenticated) {
    await keycloak.login();
  } else {
    // Try to refresh if token will expire in next 30 seconds
    try {
      await keycloak.updateToken(30);
    } catch (err) {
      // If refresh fails, force login
      await keycloak.login();
    }
  }
  return keycloak.token;
};

// ✅ Axios instance with dynamic base URL
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// ✅ Interceptor to Attach Keycloak Token to Every Request
apiClient.interceptors.request.use(
    async (config) => {
      if(config.skipAuth){
         return config;
      }
      const token = await getAuthToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // ✅ API Service to Fetch Data from Backend
  export const fetchDataFromBackend = async (endpoint, options = {}) => {
    try {
      // Destructure options to get method (default "get") and data (if any)
      const { method = 'get', data = null, ...rest } = options;
      logger.log("Fetching data from:", endpoint);
      logger.log("Options", options);
      let response;
      switch (method.toLowerCase()) {
        case 'post':
          response = await apiClient.post(endpoint, data, { ...rest });
          break;
        case 'put':
          response = await apiClient.put(endpoint, data, { ...rest });
          break;
        case 'patch':
          response = await apiClient.patch(endpoint, data, { ...rest });
          break;
        case 'delete':
          // Note: some versions of axios allow sending a request body in delete using the "data" property
          response = await apiClient.delete(endpoint, { data, ...rest });
          break;
        default:
          response = await apiClient.get(endpoint, { ...rest });
      }
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };